import { AlternativeDetailsDialogViewModel } from '@Alternatives/Alternatives/Components/AlternativeDetailsDialog';
import AlternativeDetailsDialog from "@Alternatives/Alternatives/Components/AlternativeDetailsDialog.vue";
import { DownloadBlob } from '@browser/Browser';
import { isNullOrWhitespace, numCompare, strCompare } from "@common/Common";
import EstimationsCommands from "@Evaluation/Estimations/Domain/commands-vue-component";
import EstimationsQueries from "@Evaluation/Estimations/Domain/queries-vue-component";
import { DownloadReadModel, EstimationSurveyDashboardAlternativeReadModel, PanelistDashboardPageReadModel } from '@Evaluation/Estimations/Domain/readmodels';
import { Component, mixins } from 'vue-facing-decorator';


@Component({
    components: { AlternativeDetailsDialog }
})
export default class PanelistDashboardPage extends mixins(EstimationsCommands, EstimationsQueries)
{
    get workspaceId(): number { return Number(this.$route?.params?.workspaceId ?? 0); }
    get surveyId(): number { return Number(this.$route?.params?.surveyId ?? 0); }
    get projectUserId(): number { return Number(this.$route?.params?.projectUserId ?? 0); }

    initialized: boolean = false;

    AlternativeLabel: string;
    AlternativesLabel: string;
    SurveyName: string;
    SurveyDescription: string;
    SurveyQuestionsCount: number;
    IsClosed: boolean;
    MeetingUrl: string;
    Alternatives: EstimationSurveyDashboardAlternativeReadModel[] = [];
    OrderByProgressAsc: boolean = true;
    SearchPhrase: string = null;
    alternativeDetailsDialog = new AlternativeDetailsDialogViewModel();

    get AlternativesView(): EstimationSurveyDashboardAlternativeReadModel[] 
    {
        const altCompare = (a: EstimationSurveyDashboardAlternativeReadModel, b: EstimationSurveyDashboardAlternativeReadModel) =>
        {
            let progressCompare = numCompare(a.Progress, b.Progress);

            if (this.OrderByProgressAsc)
            {
                progressCompare *= -1;
            }

            return progressCompare === 0 ? strCompare(a.Name, b.Name) : progressCompare;
        }

        let view = this.Alternatives.sort((a, b) => altCompare(a, b));

        if (!isNullOrWhitespace(this.SearchPhrase))
        {
            const phrase = this.SearchPhrase.toLowerCase();
            view = view.filter(o => o.Name.toLowerCase().indexOf(phrase) >= 0);
        }

        return view;
    }

    ToggleOrderByProgressCommand()
    {
        this.OrderByProgressAsc = !this.OrderByProgressAsc;
    }

    showAlternativeDetails(a: EstimationSurveyDashboardAlternativeReadModel)
    {
        this.alternativeDetailsDialog.show(a.Name, a.Description);
    }

    downloadVotes()
    {
        this.runExportPanelistVotesQueryV1(this.workspaceId, this.surveyId, this.projectUserId);
    }


    mounted()
    {
        //document.title = "Panelists | TransparentChoice";
        this.runPanelistDashboardPageQueryV1(this.workspaceId, this.surveyId, this.projectUserId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "PanelistDashboardPageReadModel")
        {
            const rm = model as PanelistDashboardPageReadModel;
            this.AlternativeLabel = rm.AlternativeLabel;
            this.AlternativesLabel = rm.AlternativesLabel;
            this.SurveyName = rm.SurveyName;
            this.SurveyDescription = rm.SurveyDescription;
            this.SurveyQuestionsCount = rm.SurveyQuestionsCount;
            this.IsClosed = rm.IsClosed;
            this.MeetingUrl = rm.MeetingUrl;
            this.Alternatives = rm.Alternatives;

            this.initialized = true;
        }
        else if (modelName === "DownloadReadModel")
        {
            const rm = model as DownloadReadModel;
            DownloadBlob(rm.Url);
        }
    }
}